import { Deck } from '../../types/decks';
import './DeckList.css';

interface DeckListProps {
  decks: Deck[];
  isLoading: boolean;
  onEdit: (deckId: string, name: string, cardIds: number[]) => void;
  onDelete: (deckId: string) => void;
  onSetActive: (deckId: string) => void;
}

export function DeckList({ decks, isLoading, onEdit, onDelete, onSetActive }: DeckListProps) {
  if (isLoading) {
    return (
      <div className="deck-list">
        <div className="deck-list__loading">덱 목록을 불러오는 중...</div>
      </div>
    );
  }

  if (decks.length === 0) {
    return (
      <div className="deck-list">
        <div className="deck-list__empty">
          <div className="deck-list__empty-icon">🃏</div>
          <div className="deck-list__empty-text">아직 덱이 없습니다</div>
          <div className="deck-list__empty-hint">새 덱을 만들어보세요!</div>
        </div>
      </div>
    );
  }

  return (
    <div className="deck-list">
      {decks.map((deck) => (
        <div
          key={deck.id}
          className={`deck-list__item ${deck.is_active ? 'deck-list__item--active' : ''}`}
        >
          <div className="deck-list__item-header">
            <div className="deck-list__item-info">
              <h3 className="deck-list__item-name">{deck.name}</h3>
              {deck.is_active && (
                <span className="deck-list__item-badge">기본 덱</span>
              )}
            </div>
            <div className="deck-list__item-count">
              {deck.card_ids.length} / 30
            </div>
          </div>
          <div className="deck-list__item-actions">
            <button
              className="deck-list__action-btn deck-list__action-btn--edit"
              onClick={() => onEdit(deck.id, deck.name, deck.card_ids)}
            >
              수정
            </button>
            {!deck.is_active && (
              <button
                className="deck-list__action-btn deck-list__action-btn--set-active"
                onClick={() => onSetActive(deck.id)}
              >
                기본으로 설정
              </button>
            )}
            <button
              className="deck-list__action-btn deck-list__action-btn--delete"
              onClick={() => onDelete(deck.id)}
            >
              삭제
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

